import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 20v-15l-8 11h10","key":"svg-0"}]]

const IconNumber4 = createReactComponent('outline', 'number-4', 'Number4', __iconNode);

export default IconNumber4;